import styled from 'styled-components';
import { getSpace, getGridSpans, getColor, backgroundClipPath, mq } from '@stylesheets/tools';

const StyledFilterSettings = styled.section`
  margin: 0 auto;

  .filterSettings__container .container__wrapper::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    ${backgroundClipPath('#000', '30px')};
    background: ${getColor('gray')};
  }

  .filterSettings__container .container__wrapper {
    ${getGridSpans('padding', { s: 1, m: 0.5, l: 0.5 })};
  }

  .filterSettings__selects {
    display: flex;
    flex-wrap: wrap;

    & > div {
      width: 100%;
      margin-bottom: ${getSpace('xs')};

      ${mq('m')} {
        width: min-content;
        margin-right: ${getSpace('m')};
      }

      .select__wrapper,
      .date-select__inner {
        width: 100%;

        ${mq('m')} {
          width: max-content;
        }
      }

      .select__label {
        width: 100%;
        margin-left: 0;
      }
    }
  }

  .filterSettings__browse {
    display: flex;
    flex-direction: column;
    margin-bottom: ${getSpace('l')};

    ${mq('m')} {
      align-items: center;
      flex-direction: row;
    }

    & > div {
      height: max-content;
    }
  }

  .filterSettings__browse__labels {
    display: flex;
    align-items: center;

    margin-bottom: ${getSpace('xxs')};

    ${mq('m')} {
      margin-bottom: 0;
    }
  }

  .filterSettings__browse__headline {
    border-right: 2px solid ${getColor('gray')};
    width: max-content;
    padding-right: ${getSpace('m')};
    margin-right: ${getSpace('m')};
  }

  .filterSettings__browse__filter-label {
    display: block;
    margin-right: ${getSpace('xxs')};
    text-transform: initial;
  }

  .filterSettings__topics__headline {
    margin-top: ${getSpace('s')};
    margin-bottom: ${getSpace('xxs')};
  }
`;

export default StyledFilterSettings;
